import { FC } from "react";
import styles from "./TopBlock.module.scss";
import { H2 } from "@/lib/ui/components/Typography";
import { Search } from "@/lib/ui/components/Search";

export const TopBlock: FC<{ title: string }> = ({ title }) => {
  return (
    <div className={styles.top}>
      <H2 as="h1" className={styles.top__title}>
        {title}
      </H2>
      <Search className={styles.top__inputBlock}  />
    </div>
  );
};
